// GENERATED FILE - DO NOT MODIFY

export enum ContactMethodTypeDto {
    Email = "Email",
    PhoneNumber = "PhoneNumber",
    Slack = "Slack",
    Calendly = "Calendly",
}